import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-28dc0184"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "left-container" }
const _hoisted_2 = ["hidden", "innerHTML"]
const _hoisted_3 = ["hidden"]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  id: "review-indicator-icon",
  class: "fa mr-2 fa-angle-down"
}, null, -1))
const _hoisted_5 = { id: "right-container" }
const _hoisted_6 = { id: "progress-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BasicNavigationControl = _resolveComponent("BasicNavigationControl")!
  const _component_ProgressBar = _resolveComponent("ProgressBar")!

  return (_openBlock(), _createElementBlock("div", {
    id: "information-banner-container",
    "aria-hidden": "true",
    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.closeReviewIfExpanded && _ctx.closeReviewIfExpanded(...args)))
  }, [
    _createElementVNode("div", {
      id: "inner-container",
      style: _normalizeStyle({ width: _ctx.width, maxWidth: _ctx.maxWidth })
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", {
          id: "left-inner-container",
          hidden: !_ctx.showItemProgress,
          class: _normalizeClass(_ctx.adjustmentClass),
          innerHTML: _ctx.title
        }, null, 10, _hoisted_2),
        _createElementVNode("button", {
          id: "review-progress-button",
          class: _normalizeClass(["review-button-regular-border", _ctx.adjustmentClass]),
          hidden: !_ctx.showReviewProgressButton,
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.reviewButtonClicked && _ctx.reviewButtonClicked(...args)))
        }, [
          _hoisted_4,
          _createElementVNode("span", null, _toDisplayString(_ctx.$t('review.progress')), 1)
        ], 10, _hoisted_3)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_BasicNavigationControl, {
          id: "navigation-control",
          "right-align": "true",
          "previous-button-color": "#ffffff",
          class: _normalizeClass(_ctx.adjustmentClass)
        }, null, 8, ["class"])
      ])
    ], 4),
    _createElementVNode("div", _hoisted_6, [
      _createVNode(_component_ProgressBar, {
        "progress-bar-data": _ctx.progressBarData,
        "progress-bar-color": _ctx.progressBarColor,
        hidden: !_ctx.displayProgressBar
      }, null, 8, ["progress-bar-data", "progress-bar-color", "hidden"])
    ])
  ]))
}